var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"rgba(0, 0, 0, 0.4)","position":"fixed","top":"0","bottom":"0","left":"0","right":"0","z-index":"100000","color":"white"}},[_vm._v(" Loading... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }